'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var React = require('react');
var Skeleton_web = require('../Skeleton/Skeleton.web.cjs');
var Typography_web_types = require('./Typography.web.types.cjs');
var Typography_web_styles = require('./Typography.web.styles.cjs');

/**
 * Typography wrapper component used to display text
 *
 * {@link https://aviary.fullscript.io/latest/components/typography/web-C9CGSK7F-C9CGSK7F | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/atoms/Typography/Typography.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const Typography = /*#__PURE__*/ React.forwardRef(({ variant = "body", as, intention = "neutral", colorIntensity = "neutral", isItalic = false, isLoading = false, isMarginless = false, isStrikethrough = false, isTruncated = false, fontWeight = "regular", children, customCss, ...rest }, ref)=>{
    const theme = react.useTheme();
    const styleBuilder = ()=>{
        const intensity = intention === "inverse" ? colorIntensity : colorIntensity;
        return [
            Typography_web_styles.typographySizes(variant, fontWeight, theme),
            Typography_web_styles.color(intention)[intensity],
            !isMarginless && Typography_web_styles.margin,
            isItalic && Typography_web_styles.italic,
            isStrikethrough && Typography_web_styles.strikethrough,
            isTruncated && Typography_web_styles.truncate,
            customCss
        ];
    };
    if (isLoading) {
        return /*#__PURE__*/ jsxRuntime.jsx(Skeleton_web.Skeleton, {
            variant: "typography",
            typographyType: variant,
            isFullWidth: true
        });
    }
    let Element;
    if (as) {
        Element = as;
    } else if (Object.keys(Typography_web_types.HEADING_ELEMENTS).includes(variant)) {
        Element = variant;
    } else {
        Element = "p";
    }
    return /*#__PURE__*/ jsxRuntime.jsx(Element, {
        ref: ref,
        css: styleBuilder(),
        ...rest,
        children: children
    });
});
Typography.displayName = "Typography";

exports.Typography = Typography;
//# sourceMappingURL=Typography.web.cjs.map
